import Vue from 'vue'

let message = Vue.prototype.$message;

export default function (res) {
  if (!res.success) {
    message.error('超出当前账号可管理的部门范围');
    // message.error(res.description || '请求数据失败');
  } else {
    message.success(res.description || '操作成功');
  }
};



// WEBPACK FOOTER //
// ./assets/js/http-serve/corp/showApiRes.js